import { useTranslation } from "react-i18next";

const COLORS = {
  ok: "#1f9d55",
  atencao: "#d97706",
  critico: "#dc2626",
  nao_aplicavel: "#6b7280",
  rascunho: "#6b7280",
  concluido: "#2563eb",
  aprovado: "#1f9d55",
};

// Os rotulos exibidos vem do i18next (chaves checklist.item_status_* e
// checklist.checklist_status_*), mantendo o "status" em si (ok/atencao/
// critico/nao_aplicavel/rascunho/concluido/aprovado) como identificador
// interno fixo -- e o valor realmente salvo no checklist.
const ITEM_STATUS_KEYS = {
  ok: "item_status_ok",
  atencao: "item_status_atencao",
  critico: "item_status_critico",
  nao_aplicavel: "item_status_na",
};
const CHECKLIST_STATUS_KEYS = {
  rascunho: "checklist_status_rascunho",
  concluido: "checklist_status_concluido",
  aprovado: "checklist_status_aprovado",
};

export default function StatusBadge({ status, kind = "item" }) {
  const { t } = useTranslation();
  if (!status) {
    return <span className="badge badge--vazio">{t("checklist.status_pendente")}</span>;
  }
  const key = kind === "item" ? ITEM_STATUS_KEYS[status] : CHECKLIST_STATUS_KEYS[status];
  const label = key ? t(`checklist.${key}`) : null;
  const color = COLORS[status] || "#6b7280";
  return (
    <span className="badge" style={{ backgroundColor: color }}>
      {label || status}
    </span>
  );
}
